module.exports = __webpack_public_path__ + "img/e10b413219c24256fd97b1cab085100c.png";